import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search, UserPlus, Phone } from "lucide-react";
import { api } from "../lib/api";
import { useLang } from "../lib/i18n";
import { useQuick } from "../components/Layout";
import { PageHeader, Section, StatusBadge, Empty, RowLink, Options } from "../components/common";
import { STAGES } from "../lib/constants";
import { fullName, telLink } from "../lib/helpers";

export default function Customers() {
  const { t, lang } = useLang();
  const quick = useQuick();
  const [params] = useSearchParams();
  const [q, setQ] = useState("");
  const [stage, setStage] = useState("");
  const [list, setList] = useState(null);
  const ref = useRef();
  useEffect(() => {
    if (params.get("focus")) ref.current?.focus();
  }, [params]);
  useEffect(() => {
    const id = setTimeout(() => api.get("/customers", { params: { q, stage } }).then((r) => setList(r.data)), 250);
    return () => clearTimeout(id);
  }, [q, stage]);
  return (
    <>
      <PageHeader title={t("Customers", "Clientes")} subtitle={list ? `${list.length} ${t("customers", "clientes")}` : ""}
        actions={<button className="btn-primary" onClick={() => quick.openCustomer()} data-testid="customers-new-btn"><UserPlus className="w-5 h-5" /> {t("New Customer", "Nuevo cliente")}</button>} />
      <div className="grid sm:grid-cols-[1fr_240px] gap-3 mb-4">
        <div className="relative">
          <Search className="w-5 h-5 absolute left-3 top-3.5 text-slate-400" />
          <input ref={ref} className="inp pl-10 h-14" placeholder={t("Search by name, phone, email or address", "Buscar por nombre, teléfono, correo o dirección")} value={q} onChange={(e) => setQ(e.target.value)} data-testid="customers-search-input" />
        </div>
        <select className="inp h-14" value={stage} onChange={(e) => setStage(e.target.value)} data-testid="customers-stage-filter">
          <option value="">{t("All stages", "Todas las etapas")}</option>
          <Options items={STAGES} lang={lang} />
        </select>
      </div>
      <Section testid="customers-list">
        {list && !list.length && <Empty text={t("No customers found", "No se encontraron clientes")} />}
        {list?.map((c) => (
          <div key={c.id} className="flex items-center">
            <div className="flex-1 min-w-0">
              <RowLink to={`/customers/${c.id}`} testid={`customer-row-${c.id}`}>
                <span className="grid place-items-center w-10 h-10 rounded-full bg-slate-100 font-bold text-slate-600 shrink-0">{(c.first_name || "?")[0]}</span>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold truncate">{fullName(c)}</div>
                  <div className="text-xs text-slate-500 truncate">{c.phone} {c.property_address && `· ${c.property_address}`}</div>
                </div>
                <StatusBadge status={c.stage} />
              </RowLink>
            </div>
            {c.phone && <a href={telLink(c.phone)} className="btn-ghost btn-sm mx-1 px-2" aria-label="Call" data-testid={`customer-call-${c.id}`}><Phone className="w-5 h-5" /></a>}
          </div>
        ))}
      </Section>
    </>
  );
}
